<template>
  <div class="form-group">
    <label
      :for="`input-shopper-custprop-${Guid}-${_uid}`"
      class="col-md-3 control-label"
      :class="{ 'text-red': Recommended && value.length < 1 }"
    >
      {{ Title }}
      <span v-if="Recommended">*</span>
    </label>
    <div class="col-md-9">
      <Select2
        class="form-control"
        :id="`input-shopper-custprop-${Guid}-${_uid}`"
        :allowClear="true"
        :tags="AllowCustomValues"
        :multiple="true"
        :placeholder="' '"
        :value="value"
        @change="updateValue"
        @beforeOpen="scrollIntoViewMobile"
        @close="selectClosed()"
      >
        <option
          v-for="element in ListValues"
          :key="element.ValueGuid"
          :value="element.ValueGuid"
        >
          {{ element.Value }}
        </option>
      </Select2>
    </div>
  </div>
</template>
<script>
import Select2 from "./../../Tools/Select2";

export default {
  name: "MultiSelectInput",
  components: { Select2 },
  props: {
    Title: String,
    Guid: String,
    ListValues: { type: Array, default: () => [] },
    Recommended: { type: Boolean, default: false },
    AllowCustomValues: { type: Boolean, default: false },
    value: { type: Array, default: () => [] },
  },
  data() {
    return {
      scrollPositionOk: false,
    };
  },
  methods: {
    updateValue(newValue) {
      this.$emit("input", newValue);
    },
    selectClosed() {
      $("#scrollOverflowBlock").hide("slow");
      this.scrollPositionOk = false;
    },
    scrollIntoViewMobile(e) {
      if (!this.globals.isMobileBrowser) return;
      if (this.scrollPositionOk) return;
      else e.preventDefault();

      let currentOffsetTop = $(e.target.parentNode.parentNode).offset().top;
      if (currentOffsetTop < 100) {
        // Select already at top of the screen
        this.scrollPositionOk = true;
        $(e.target).select2("open");
        return;
      }

      let modal = $(e.target).closest(".modal");
      if (modal[0].scrollHeight - modal.scrollTop() - modal.outerHeight() < 1) {
        // reached lowest scroll position
        if (
          !this.globals.isSafariBrowser &&
          $("#scrollOverflowBlock").is(":hidden")
        ) {
          $("#scrollOverflowBlock").css("display", "block");
          e.target.parentNode.parentNode.scrollIntoView();
        }
        this.scrollPositionOk = true;
        $(e.target).select2("open");
        return;
      }

      e.target.parentNode.parentNode.scrollIntoView({ behavior: "smooth" });
      setTimeout(() => {
        $(e.target).select2("open");
      }, 500);
    },
  },
};
</script>



// WEBPACK FOOTER //
// MultiSelectInput.vue?847df8a0